import { Link, Route } from "react-router-dom";
import Layout from "./Layout";
import Users from "./pages/Users";
import { loadUser, loadUsers } from "./apis/userAPI";
import UserChanges from "./pages/UserChanges";
import Groups from "./pages/Groups";
import { loadGroup, loadGroups } from "./apis/groups";
import GroupChanges from "./pages/GroupChanges";


const mainRouter = () => (
  <Route path="/settings" element={<Layout />} handle={{ crumb: () => <Link to={'/sales'}>Overview</Link>}}>
    <Route index element={<Users />} loader={loadUsers} />
    <Route path="users" element={<Users />} loader={loadUsers} />
    <Route path="users/:action" element={<UserChanges />} loader={params => loadUser(params.params.action)} />
    <Route path="groups" element={<Groups />} loader={loadGroups} />
    <Route path="groups/:action" element={<GroupChanges />} loader={params => loadGroup(params.params.action)} />
  </Route>
);


export default mainRouter;